import { css } from '@emotion/core'
import { mediumUp, mediumOnly } from 'Utils'

export default ({ theme: { typography, colors } }) => css`
  width: 100%;
  margin: 1.2rem 0;
  display: flex;
  flex-direction: column;
  outline: 1px solid ${colors.secondary};

  .content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: ${colors.complementary.primary};
    align-items: center;
    text-align: center;
    * {
      margin: 0.5rem;
    }
    padding: 0.8rem 0;
  }

  .title {
    text-transform: uppercase;
    font-size: ${typography.sizes.larger};
    font-weight: bold;
    color: ${colors.primary};
    line-height: ${typography.headings.lineHeight};
    font-family: ${typography.body.fontFamily};
    letter-spacing: -1px;
  }

  .intro {
    max-width: 400px;
    max-width: 80%;
    text-align: center;
    line-height: 1.2em;
    font-weight: normal;
    margin-bottom: 1.2rem;
    color: ${colors.primary};
    font-family: ${typography.headings.fontFamily};
  }

  .button {
    text-transform: uppercase;
    color: ${colors.primary};
    display: block;
    width: fit-content;
    padding: 0.8rem 1.8rem;
    border: 1px solid ${colors.primary};
  }

  @media ${mediumUp} {
    display: flex;
    flex-direction: row;

    img {
      align-self: start;
      width: 66%;
    }
    .content {
      width: 34%;
    }
  }

  @media ${mediumOnly} {
    display: flex;
    flex-direction: column;

    img {
      width: 100%;
    }
    .content {
      width: auto;
    }
  }
`
